module.exports = __webpack_public_path__ + "media/fundraising_sim/fun_img01-88a7f4f0.png";